/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingMelcoModelsCustomWarning
 */
export interface DigitizingMelcoModelsCustomWarning {
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoModelsCustomWarning
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoModelsCustomWarning
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoModelsCustomWarning
     */
    message?: string | null;
}

export function DigitizingMelcoModelsCustomWarningFromJSON(json: any): DigitizingMelcoModelsCustomWarning {
    return DigitizingMelcoModelsCustomWarningFromJSONTyped(json, false);
}

export function DigitizingMelcoModelsCustomWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoModelsCustomWarning {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function DigitizingMelcoModelsCustomWarningToJSON(value?: DigitizingMelcoModelsCustomWarning | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'source': value.source,
        'message': value.message,
    };
}


